import { getFormValues } from 'redux-form'
import { getAppointments } from 'selectors/getAppointments'
import { APPOINTMENT_FORM_NAME } from 'constant'
import Review from './components/Review'
import VehicleSelector from './components/VehicleSelector'
import StoreLocationSelector from './components/StoreLocationSelector'
import ServiceSelector from './components/ServiceSelector'
import DateTimeSelector from './components/DateTimeSelector'
import ContactInfo from './components/ContactInfo'

export const getAppointmentFormValues = getFormValues(APPOINTMENT_FORM_NAME)

export const getCompletedSteps = state => {
  const {
    activeVehicleId,
    selectedStore,
    catalogRefIds,
    appointmentDate,
    firstName,
    lastName,
    phoneNumber,
    email,
    userPlan
  } = getAppointmentFormValues(state) || {}

  const { isTrailer } = getAppointments(state)

  const steps = [
    {
      title: 'Select Vehicle',
      icon: 'car-black',
      cartridgeType: 'BOTVehicleSelector',
      component: VehicleSelector,
      isDone: Boolean(activeVehicleId || isTrailer)
    },
    {
      title: 'Select location',
      icon: 'car-location',
      cartridgeType: 'BOTStoreLocation',
      component: StoreLocationSelector,
      isDone: Boolean(selectedStore)
    },
    {
      title: 'Select services',
      icon: 'car-service',
      cartridgeType: 'BOTServicesSelector',
      component: ServiceSelector,
      isDone: Boolean(catalogRefIds && catalogRefIds.length)
    },
    {
      title: 'Select time and date',
      icon: 'car-calendar',
      cartridgeType: 'BOTDateTimeSelector',
      component: DateTimeSelector,
      isDone: Boolean(appointmentDate && appointmentDate.time)
    },
    {
      title: 'Contact Information',
      icon: 'contact-black',
      component: ContactInfo,
      isDone: Boolean(firstName && lastName && phoneNumber && email && userPlan)
    },
    {
      title: 'Review',
      component: Review,
      isDone: true
    }
  ]

  const firstUndoneStepIndex = steps.findIndex(step => !step.isDone)
  const allDone = firstUndoneStepIndex === -1

  for (let i = 0; i < steps.length; i += 1) {
    steps[i].isDone = allDone || i < firstUndoneStepIndex
    steps[i].isActive = allDone || i <= firstUndoneStepIndex
  }

  return steps
}
